import React from "react";
import Content from "./Content";
import ContentDesktop from "./ContentDesktop";
import businessData from "./BusinessData";
import businessDataDesktop from "./BizDataDesktop";
// import { Image, Button } from "react-bootstrap";
import ContentSectionStyles from "./css/Content.module.css";
import { useMediaQuery } from "@mui/material";

const Business = () => {
  const mainContainer = ContentSectionStyles.mainContainer;
  const titleContainer = ContentSectionStyles.titleContainer;
  const subtitleContainer = ContentSectionStyles.subtitleContainer;

  const hide = ContentSectionStyles.hide;
  const matches1024 = useMediaQuery("(min-width:1024px)");

  const contentList = businessData.map((data) => {
    return <Content key={data.id} {...data} />;
  });

  // for desktop
  const contentListDesktop = businessDataDesktop.map((data) => {
    return <ContentDesktop key={data.id} {...data} />;
  });

  return (
    <>
      <main className={mainContainer}>
        <section className={titleContainer}>
          <h1>
            Small Business <br className={hide} /> Services List
          </h1>
        </section>

        {/* <section className={subtitleContainer}>
          <h2>Hiring Services</h2>
        </section> */}

        {!matches1024 && contentList}
        {matches1024 && contentListDesktop}
      </main>
    </>
  );
};

export default Business;
